module.exports = __webpack_public_path__ + "img/code-bar.55a565ec.svg";